(() => {
  if (window.sasPersonalizationCartLoaded) return;
  window.sasPersonalizationCartLoaded = true;
  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  const variants = {Personalization:67800606081223,'Team Number':67796332413127};
  const legacyNameVariant = 67796332380359;
  const feeIds = new Set([...Object.values(variants), legacyNameVariant]);
  let chain = Promise.resolve();
  async function json(url, body) {
    const response = await nativeFetch(root + url, body ? {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)} : {headers:{Accept:'application/json'}});
    const result = await response.json();
    if(!response.ok) throw new Error(result.description || 'Unable to update personalization charges.');
    return result;
  }
  async function normalize() {
    let cart = await json('cart.js');
    const updates = {};
    const additions = [];
    for(const parent of cart.items) {
      const group = parent.properties?._sas_personalization_group;
      if (!group || feeIds.has(parent.variant_id)) continue;
      cart.items.filter(item => item.variant_id === legacyNameVariant && item.properties?._sas_personalization_group === group).forEach(item => { updates[item.key] = 0; });
      for(const [property,id] of Object.entries(variants)) {
        const text = String(parent.properties[property] || '').trim();
        const children = cart.items.filter(item => item.variant_id === id && item.properties?._sas_personalization_group === group);
        if(text && !children.length) additions.push({id,quantity:parent.quantity,parent_line_key:parent.key,properties:{'Print text':text,_sas_personalization_group:group}});
        children.forEach((child,index) => {
          const quantity = text && index === 0 ? parent.quantity : 0;
          if(child.quantity !== quantity) updates[child.key] = quantity;
        });
      }
    }
    if(Object.keys(updates).length) cart = await json('cart/update.js',{updates});
    if(additions.length) {await json('cart/add.js',{items:additions}); cart = await json('cart.js');}
    return {cart,changed:!!Object.keys(updates).length || !!additions.length};
  }
  function reconcile() {
    const task = chain.catch(() => {}).then(normalize);
    chain = task;
    return task;
  }
  window.fetch = async function(input, init) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const response = await nativeFetch(input,init);
    if(response.ok && /\/cart\/(?:change|update)(?:\.js)?(?:\?|$)/.test(url)) {
      const {cart} = await reconcile();
      return new Response(JSON.stringify(cart),{status:response.status,headers:{'Content-Type':'application/json'}});
    }
    return response;
  };
  let checkoutReady = false;
  async function ensureCheckout(event, target) {
    if(checkoutReady) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await reconcile();
      checkoutReady = true;
      if(target.tagName === 'FORM') target.requestSubmit(); else target.click();
      setTimeout(() => {checkoutReady=false;},1000);
    } catch(error) {window.alert(error.message);}
  }
  window.addEventListener('click',event => {
    const target = event.target.closest?.('[name="checkout"],a[href="/checkout"],a[href^="/checkout?"]');
    if(target) ensureCheckout(event,target);
  },true);
  window.addEventListener('submit',event => {
    const form = event.target;
    if(form.action && /\/checkout(?:\?|$)/.test(form.action)) ensureCheckout(event,form);
  },true);
  if(/\/cart\/?$/.test(location.pathname)) reconcile().then(({changed}) => {if(changed) location.reload();}).catch(error => console.error(error.message));
})();
